import React, { useState } from "react";
import { FormOrganizerProps } from "interfaces/forms/FormOrganizerProps";
import { FormViewer } from "./FormViewer";
import FormEditor from "./editor/FormEditor";
import { Form } from "models/forms/Form";
import FormList from "./FormList";
import { utilities } from "utils/utilities";
import { ApiService } from "services/ApiService";

export const FormOrganizer: React.FC<FormOrganizerProps> = ({ ownerId }) => {
  const [selectedFormId, setSelectedFormId] = useState<string>("");
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);

  const handleCreateNew = () => {
    setSelectedFormId(utilities.DEFAULT_GUID);
    setIsEditing(true);
  };

  const handleFormSelectionClick = (formId: string | Form) => {
    const idToSet = typeof formId === "string" ? formId : formId.id;

    setSelectedFormId(idToSet);
    setIsEditing(false);
  };

  const handleEditButtonClick = () => {
    if (selectedFormId.length === 0) return;
    setIsEditing(true);
  };

    const handleDelete = async () => {
        const response = (await ApiService.deleteForm(selectedFormId)).success;

        setSelectedFormId("");
        setIsEditing(false);
        
        handleCRUD_Operations();
    }

    // This method here is so that the formlist can be updated if
    // a new form was created or deleted.
    const handleCRUD_Operations: any = () => {
      setCount((c) => c + 1);
    }

    return (
      <div className="flex h-screen bg-gray-50">
        {/* Left Side: Form List with space from left screen edge */}
        <div className="w-1/4 pl-6 pr-4 border-r border-gray-300 py-5 overflow-y-auto">
          <h1 className="text-xl font-semibold mb-4 text-center">Form Organizer</h1>
          <FormList
            ownerId={ownerId}
            onCreateNew={handleCreateNew}
            onSelect={handleFormSelectionClick}
            useDtos={true}
            formListCount={count}
          />
        </div>
    
        {/* Right Side: Viewer or Editor */}
        <div className="flex-1 p-6 overflow-y-auto flex justify-center">
          {selectedFormId && !isEditing && (
            <div className="w-full max-w-2xl">
              {/* Form Viewer Box */}
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-6 mb-6">
                <FormViewer formId={selectedFormId} form={null} isDisabled={false} />
              </div>
    
              {/* Action Buttons */}
              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={handleEditButtonClick}
                  className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition-colors"
                >
                  Edit
                </button>
                <button
                  id={selectedFormId}
                  type="button"
                  onClick={handleDelete}
                  className="px-4 py-2 bg-red-500 text-white text-sm font-medium rounded hover:bg-red-600 transition-colors"
                >
                  Delete
                </button>
              </div>
            </div>
          )}
    
          {isEditing && (
            <FormEditor
              formId={selectedFormId}
              onSaveNewOrDelete={handleCRUD_Operations}
            />
          )}
        </div>
      </div>
    );
    
    
};
